import React, { useMemo } from "react";
import { DefaultSuggestionList } from "stream-chat-react";

function SuggestionListWithHeaderComponent(props) {
  // debugger;
  let header = "";
  const filteredValue = useMemo(() => {
    let values = props.values || [];
      // TRIGGER: @ (Mentions)
    // Filter out users that don't have a name property
    // Users without names are incomplete profiles or system users
    if (props.currentTrigger === "@") {
      const filtered = values.filter(
        (user) => user && user.name && user.name.trim() !== ""
      );

      // Explicitly add everyone option at the top if it's not already included
      return [
        { id: "everyone", name: "everyone" },
        ...filtered,
      ];
    }
   
  // TRIGGER: / (Commands)
  // Disabled - return empty list
    if (props.currentTrigger === "/") {
      return [];
    }

    // TRIGGER: : (Emojis)
    // Use default emoji list from Stream
    if (props.currentTrigger === ":") {
      header = "";
    }

    return values;
  }, [props.values, props.currentTrigger]);

  const newProps = {
    ...props,
    values: filteredValue,
  };

  return (
    <>
      <div className="suggestion-list__header">{header}</div>
      <DefaultSuggestionList {...newProps} />
    </>
  );
}

// Memoized version
export const SuggestionListWithHeader = React.memo(
  SuggestionListWithHeaderComponent
);
